@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.buttons {
  width: 100%;
  display: flex;
  gap: 5px;
}

.buttonContainer {
  width: 100%;
  display: flex;
}
